// extracted by mini-css-extract-plugin
export default {"slidecontainer":"mDvzI","item":"JtcLx","attach_hub_files_to":"fMX34","attach_hub_files_desc":"v3twZ"};